<template>
  <v-main>
    <v-container fluid style="max-width: 400px;" class="pa-0">
      <v-row class="px-0">
        <v-col>
          <header1 class="my-5">Zeitmessung</header1>
          <div v-if="(isFree)" class="text-xl-center mb-3 mt-10 ml-2">
            <div class="mt-3 pa-3"
                 style="border: 1px dashed dodgerblue; width: calc( 100% - 8px); height: 620px; border-radius: 5px; background-color: #ffffff30">
              <span class="headline">Zeitaktivitäten mit der Stoppuhr tracken?</span>
              <vc-donut class="mt-10 mb-3" :sections="sections" :has-legend="false" legend-placement="bottom">
                <span class="display-1">{{ timeString }}</span><br>
                <span class="body-2">{{ "Yoga" }}</span>
              </vc-donut>
              <div class="d-flex justify-center">
              <v-btn class="mt-5" color="grey white--text">
                <v-icon v-text="'mdi-play-circle'"></v-icon>
              </v-btn>
              <v-btn class="mt-5 ml-3" :color="`${!startTime ?'gelb':'accent'} white--text`">
                <v-icon v-text="!startTime ? 'mdi-play-circle' : 'mdi-stop-circle'"></v-icon>
              </v-btn>
              </div>
              <br/>
              Go <pro/> für insgesamt 10 Lebensbereiche bis zu 100 Aktivitäten, SMS-Erinnerung, Zähler und Stoppuhr!
              <br/><br/>
              <v-btn rounded class="d-flex mx-10 gelb dunkelblau--text" href="https://www.digistore24.com/product/410225"
                     target="_blank">Upgrade auf aimz PRO</v-btn>
            </div>
          </div>
          <div v-else class="ml-5 mr-5 mt-10 px-2">
            <vc-donut class="mt-10 mb-3" :sections="sections" :has-legend="false" legend-placement="bottom">
              <span class="display-1">{{ timeString }}</span><br>
              <span class="body-2">{{ (selected_activity || {name: 'Aktivität auswählen'}).name }}</span>
            </vc-donut>
            <!--        <template v-for="(bereich, i) in bereiche">-->
            <!--          <span class="overline ml-2" :key="bereich">{{bereich}}</span>-->
            <!--          <v-slider class="my-auto mb-n5" v-model="erfolgsmatrix[bereich]" :key="'slider_'+bereich" :color="(sections[i]||[]).color||'pink'" track-color="grey" always-dirty min="0" max="100"></v-slider>-->
            <!--        </template>-->
            <v-select class="mt-5" label="Aktivität" :items="time_activities" v-model="selected_activity" :disabled="!!startTime">
            </v-select>

            <v-btn class="mt-5 d-flex mx-auto" @click="toggle" :color="`${!startTime ?'gelb':'accent'} white--text`" :disabled="!selected_activity">
              <v-icon class="mr-2" v-text="!startTime ? 'mdi-play-circle' : 'mdi-stop-circle'"></v-icon>
              {{ !startTime ? 'Beginnen' : 'Beenden' }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <div class="d-flex">
        <v-btn class="mx-auto mt-3 mb-3" href="https://youtu.be/zky94sg8B4Y" target="_blank">
          <v-icon class="mr-2">mdi-play-box-outline</v-icon> Videoanleitung
        </v-btn>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import Pro from "@/components/Pro";

const {DateTime} = require("luxon");
import Duration from 'luxon/src/duration.js'
import Header1 from "@/components/Header1";
import CenterContainer from "@/components/CenterContainer";
import Kinds from "@/components/Kinds";
import Activity from "@/components/Activity";
import Datum from "@/components/Datum";
import ActivityLibrary from "@/components/ActivityLibrary";
import BEREICHE from "@/components/Bereiche";

export default {
  name: "Stoppuhr",
  components: {CenterContainer, Header1, Pro},
  data() {
    return {
      bereiche: [
        {name: BEREICHE.NAMES[0], color: BEREICHE.COLORS[0], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[1], color: BEREICHE.COLORS[1], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[2], color: BEREICHE.COLORS[2], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[3], color: BEREICHE.COLORS[3], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[4], color: BEREICHE.COLORS[4], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[5], color: BEREICHE.COLORS[5], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[6], color: BEREICHE.COLORS[6], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[7], color: BEREICHE.COLORS[7], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[8], color: BEREICHE.COLORS[8], activities: [], selected: undefined},
        {name: BEREICHE.NAMES[9], color: BEREICHE.COLORS[9], activities: [], selected: undefined},
      ],
      selected_activity: undefined,
      all_activities: [],
      time_activities: [],
      sections: [
        {value: 0, label: "", color: "#8c9eff"},
        {value: 100, label: "", color: "#cfcfcf"},
      ],
      timer: undefined,
      startTime: undefined,
      stopTime: undefined,
      timeString: "00:00:00",
      offsetDuration:undefined,
    };
  },
  destroyed() {
    clearInterval(this.timer);
  },
  mounted() {
    if (!this.$app.is_logged_in) {
      this.$store.commit("set", {key: "intern", value: false});
      if (this.$route.path != "/")
        this.$router.replace("/");
      return;
    }
    this.$store.commit("set", {key: "intern", value: true});
    if (this.isFree) {
      this.startTime = DateTime.fromJSDate(new Date(Date.now()-1234000));
      this.offsetDuration = Duration.fromMillis(0);
      this.timer = setInterval(this.tick, 1000);
      return;
    }
    //
    // load starttime from storage
    var startTimeIso=this.$app.load("startTimeIso");
    if (startTimeIso) {
      var loaded_startTime=DateTime.fromISO(startTimeIso);
      if (DateTime.local().diff(loaded_startTime).as('hours')>=24) {
        this.$app.save("startTimeIso", undefined);
        loaded_startTime=undefined;
      }
      this.startTime=loaded_startTime;
    }
    this.load();
  },
  methods: {
    toggle() {
      if (this.timer)
        this.stop();
      else
        this.start();
    },
    start() {
      if (!this.startTime) {
        this.startTime = DateTime.local();
        this.$app.save("startTimeIso", this.startTime.toISO());
      }
      this.timer = setInterval(this.tick, 1000);
    },
    stop() {
      this.stopTime = DateTime.local();
      if (this.timer)
        clearInterval(this.timer);
      this.timer = undefined;
      var diff= this.stopTime.diff(this.startTime);
      this.$app.save("startTimeIso", undefined);
      this.startTime=undefined;
      //this.sections = [
      //  {value: 0, label: "", color: "#8c9eff"},
      //  {value: 100, label: "", color: "#cfcfcf"},
      //];
      //this.timeString="00:00:00";
      this.updateRecord(this.selected_activity, diff);
    },
    tick() {
      var diff = Duration.fromObject({'minutes':29, 'seconds':12});
      var time = DateTime.local();
      //console.log({duration:this.offsetDuration, startTime:this.startTime});
      if (this.isFree)
        this.offsetDuration = Duration.fromMillis(0);
      diff = time.diff(this.startTime || time).plus(this.offsetDuration);
      this.timeString = diff.toFormat("hh:mm:ss");
      var v1 = 0;
      var v2 = 100;
      if (diff.as('seconds') < 60) {
        v1 = diff.as('seconds');
      } else {
        v1 = (diff.as('minutes') % 60) / 60.0 * 100
      }
      v2 = 100 - v1;
      //console.log({v1, v2, diff})
      this.sections = [
        {value: v1, label: "", color: "#8c9eff"},
        {value: v2, label: "", color: "#cfcfcf"},
      ];
    },
    async load() {
      this.dateTime = DateTime.fromJSDate(this.date);
      this.all_activities = [];
      var activities = (await this.$backend.get_all_objects(Kinds.KIND_ACTIVITY)||[]).filter(x=>!x.deleted);
      var bereicheByName = {};
      if (!this.bereiche)
        return;
      this.bereiche.forEach(b => {
        b.activities = [];
        bereicheByName[b.name] = b
      });
      if (!activities)
        return;
      activities.forEach(activity => {
        if (!activity.name)
          return;
        if (!this.isEingabeToday(activity))
          return;
        var b = bereicheByName[activity.bereich];
        if (!b)
          return;
        b.activities.push(activity);
      });
      this.bereiche.forEach(b => {
        b.activities.sort((a, b) => a.name > b.name ? 1 : -1);
        b.activities.forEach(a => {
          this.all_activities.push(a);
          if (a.unit == "Minuten" || a.unit == "Stunden" || a.unit == "Zeit")
            this.time_activities.push({text: a.name, value: a});
        });
      });
      //
      // load activity from store
      var aid=this.$app.load("stoppuhrActivityId");
      this.selected_activity = this.all_activities.filter(a=>a.id==aid)[0];
      if (!this.selected_activity) {
        this.$app.save("stoppuhrActivityId", undefined);
        this.$app.save("startTimeIso", undefined);
      }
      await this.updateOffsetDuration(this.selected_activity);
      // auto-start timer if it is still running
      if (this.selected_activity && this.startTime) {
        this.start();
      }
    },
    async updateOffsetDuration(activity){
      var record=await this.load_record(activity, Datum.today());
      this.offsetDuration=this.getDuration(activity, record);
      this.tick();
    },
    async load_record(activity, date) {
      if (!activity)
        return undefined;
      var id = Activity.makeRecordId(Datum.to_iso(date), activity.id);
      console.log("load_record: "+ id)
      var record = await this.$backend.get_object(Kinds.KIND_RECORD, id);
      return record;
    },
    async save_record(activity, date, value) {
      var id = Activity.makeRecordId(Datum.to_iso(date), activity.id);
      var record = {id, activity: activity.id, date: Datum.to_iso(date), value};
      record=await this.$backend.set_object(Kinds.KIND_RECORD, id, record);
      this.$events.$emit("notify", "Gespeichert");
      this.$events.$emit("update_streak");
      return record;
    },
    async updateRecord(activity,diff){
      var value=0;
      var record=await this.load_record(activity, Date.now());
      console.log({activity, record});
      var time = this.getDuration(activity, record);
      var new_time=time.plus(diff);
      if (activity.unit == "Stunden")
        value=new_time.as('hours');
      else
        value=new_time.as('minutes');
      this.save_record(activity, Datum.today(), value);
    },
    getDuration(activity, record) {
      if (this.isFree)
        return Duration.fromObject({'minutes':30});
      if (!activity)
        return Duration.fromMillis(0);
      var unit=activity.unit == "Stunden" ? 'hours' : 'minutes';
      var obj={};
      obj[unit]=(record||{}).value||0;
      var time=Duration.fromObject(obj);
      return time;
    },
    onSaved(activity) {
      var idx = this.all_activities.findIndex(x => x == activity);
      if (idx < 0 || idx + 1 >= this.all_activities.length)
        return;
      // // select next activity
      // this.selected_activity = this.all_activities[idx + 1];
      // this.bereiche.forEach(b => {
      //   if (b.name == this.selected_activity.bereich)
      //     b.selected = this.selected_activity;
      // });
    },
    getBereichForActivity(activity) {
      return this.bereiche.find(b => b.name == activity.bereich);
    },
    GetActivities(bereich) {
      return bereich.activities.filter(a => this.isEingabeToday(a));
    },
    isEingabeToday(a) {
      var eingabe = false;
      if ((a.input || ActivityLibrary.INPUT_DAILY) == ActivityLibrary.INPUT_DAILY) eingabe = true;
      if (this.dateTime.weekday == 1 && a.input == ActivityLibrary.INPUT_MO) return true;
      if (this.dateTime.weekday == 2 && a.input == ActivityLibrary.INPUT_DI) return true;
      if (this.dateTime.weekday == 3 && a.input == ActivityLibrary.INPUT_MI) return true;
      if (this.dateTime.weekday == 4 && a.input == ActivityLibrary.INPUT_DO) return true;
      if (this.dateTime.weekday == 5 && a.input == ActivityLibrary.INPUT_FR) return true;
      if (this.dateTime.weekday == 6 && a.input == ActivityLibrary.INPUT_SA) return true;
      if (this.dateTime.weekday == 7 && a.input == ActivityLibrary.INPUT_SO) return true;
      //console.log("Eingabe => " + a.name + " => " + a.input + " => " + (eingabe ? "ja" : "#### NEIN ###"));
      return eingabe;
    },
    getColorFor(activity) {
      var bereich = this.getBereichForActivity(activity);
      if (!bereich)
        return "red";
      return bereich.color;
    }
  },
  computed: {
    isFree() {
      return this.$app.isFree;
    },
    isSilver() {
      return this.$app.isSilver;
    },
    isGold() {
      return this.$app.isGold;
    },
  },
  watch:{
    selected_activity(n, o){
      if (this.isFree)
        return;
      this.$app.save("stoppuhrActivityId", n?n.id:undefined);
      if (o && n!=o) {
        this.$app.save("startTimeIso", undefined);
        this.startTime=undefined;
        this.timeString="00:00:00";
      }
      this.updateOffsetDuration(n);
    }
  }
}
</script>

<style scoped>

</style>